import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=6cb2dec1&scoped=true"
import script from "./GroupTable.vue?vue&type=script&lang=js"
export * from "./GroupTable.vue?vue&type=script&lang=js"
import style0 from "./GroupTable.vue?vue&type=style&index=0&id=6cb2dec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb2dec1",
  null
  
)

export default component.exports